import "./webAppSingle.css";
import Footer from "../../components/footer/Footer";
import ReactPlayer from "react-player";
// import IMAGES from "../../images/images";
import { webAppData } from "../../data";
import { useLocation } from "react-router";
// import { useState } from "react";

// import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function WebAppSingle() {
    const location = useLocation();
    const id = location.pathname.split('/')[2];
    // const [ app, setApp ] = useState({});

    console.log("id>>", id);

    


    return (
        <div className="appSingle">
            <div className="appSingle__wrapper">
                <div className="appsingle__title">
                    <h1>
                        {webAppData[id].title}
                    </h1>
                </div>
                <section className="appSingle__contentWrapper">
                    <div className="appSingle__image">
                        <>
                        {webAppData[id].youtube ? 
                        <ReactPlayer
                            url={webAppData[id].youtube}
                            className="react-player"
                            playing
                            width="100%"
                            height="100%"
                            controls={true}
                        />
                        :
                        <img src={webAppData[id].img} alt="" />
                        }
                        </>
                    </div>
                    <a href={webAppData[id].code} target='_blank' rel='noopener noreferrer'>
                        <h4>
                        View Source Code
                        </h4>
                    </a>
                    <h2>Description</h2>
                    <div className="appSingle__textArea">
                        <p className>
                            {webAppData[id].summaryA}
                        </p>
                        <p>
                            {webAppData[id].summaryB}
                        </p>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}
